import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PrivateRoute } from '../../elements';
import { ActionsPage } from '../actions';
import { AdminPage } from '../admin';
import { LoginPage, LoginPasswordPage, LogoutPage, SessionPage, UnauthorizedPage } from '../auth';
import { UserContext } from '../contexts';
import { EwosPage } from '../ewos';
import { HelpPage } from '../help';
import { HomePage } from '../home';
import { Report1Page, ReportsPage } from '../reports';
import { RisksPage } from '../risks';
import { SmatPlansPage } from '../smat-plans';
import { SmatsPage } from '../smats';

export function Routes() {
  const { user } = useContext(UserContext);
  const isUser = () => user !== undefined;

  return (
    <Switch>
      <Route exact path="/session" component={SessionPage} />
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/login-password" component={LoginPasswordPage} />
      <Route exact path="/logout" component={LogoutPage} />
      <Route exact path="/unauthorized" component={UnauthorizedPage} />
      <Route exact path="/help" component={HelpPage} />
      <Route exact path="/help/documents" component={HelpPage} />
      <PrivateRoute exact path="/" component={HomePage} canOpen={isUser} />
      <PrivateRoute exact path="/smats" component={SmatsPage} canOpen={isUser} />
      <PrivateRoute exact path="/risks" component={RisksPage} canOpen={isUser} />
      <PrivateRoute exact path="/actions" component={ActionsPage} canOpen={isUser} />
      <PrivateRoute exact path="/ewos" component={EwosPage} canOpen={isUser} />
      <PrivateRoute exact path="/smat-plans" component={SmatPlansPage} canOpen={isUser} />
      <PrivateRoute exact path="/reports" component={ReportsPage} canOpen={isUser} />
      <PrivateRoute exact path="/reports/report-1" component={Report1Page} canOpen={isUser} />
      <PrivateRoute exact path="/admin" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/users" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/roles" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/roles/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/locations" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/areas" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/risk-priorities" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/risk-categories" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/system-settings" component={AdminPage} canOpen={isUser} />
    </Switch>
  );
}
